import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { useFormik, getIn } from "formik";
import * as Yup from "yup";
import CONSTANTS, {
  PRODUCT_CATEGORY_FORM_ID,
  PRODUCT_CODES_FORM_ID,
  Product_Code_Form_Constants,
} from "../../constants/constants";
import {
  fetchRuntimeFormData,
  postRuntimeFormData,
} from "../../services/FormService";
import {
  Autocomplete,
  Box,
  FormHelperText,
  TextField,
  FormControl,
  MenuItem,
  Select,
  Button,
} from "@mui/material";
import { pushNotification } from "../../redux/actions";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  productCodeFormContainer: {
    width: "100%",
  },

  formSection: {
    display: "flex",
    flexDirection: "column",
    gap: 15,
  },
  btnSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 10,
    gap: 20,
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 10,
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
    gap: 5,
  },
  fieldLabel: {},
  fieldinput: {
    minWidth: "240px !important",
  },
  discriptionInput: {
    minWidth: "480px !important",
  },
}));

const CreateProductCode = (props) => {
  const { data, setOpen, setRefresh } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const [productCategories, setProductCategories] = useState([]);

  const [initalStateValues, setInitalStateValues] = useState({
    productCode: data?.productCode || null,
    productCategory: data?.productCategory || "",
    productTitle: data?.productTitle || "",
    productStatus: data?.productStatus || "",
    // startDate: data?.startDate || "",
    // endDate: data?.endDate || "",
    // description: data?.description || "",
    proposalFormId: "",
  });

  const formOne = useFormik({
    initialValues: initalStateValues,
    validationSchema: Yup.object({
      productCode: Yup.string()
        .required(Product_Code_Form_Constants.productCode)
        .matches(/^[0-9]+$/, "Product code must be a valid number"),
      productCategory: Yup.string().required(
        Product_Code_Form_Constants.productCategory
      ),
      productTitle: Yup.string().required(
        Product_Code_Form_Constants.productTitle
      ),
      productStatus: Yup.string().required(
        Product_Code_Form_Constants.productStatus
      ),
      // startDate: Yup.string().required(Product_Code_Form_Constants.startDate),
      // endDate: Yup.string().required(Product_Code_Form_Constants.endDate),
      // description: Yup.string().required(
      //   Product_Code_Form_Constants.description
      // ),
    }),
    onSubmit: (values, { setSubmitting }) => {
      handleFinalSubmit(values, setSubmitting);
    },
    enableReinitialize: true,
  });

  const handleFinalSubmit = async (values: any, setSubmitting: any) => {
    setSubmitting(true);
    handleFormSubmit();
  };

  const getProductCategories = async () => {
    const response = await fetchRuntimeFormData(
      PRODUCT_CATEGORY_FORM_ID,
      0,
      10000
    );

    const filteredProductCategories = response?.data?.content?.map((item) => {
      return item?.formData?.productCategory;
    });

    setProductCategories(filteredProductCategories || []);
  };

  const handleFormSubmit = async () => {
    if (data?.id) {
      const body = {
        formId: PRODUCT_CODES_FORM_ID,
        id: data?.id,
        formData: {
          productCode: parseInt(formOne.values.productCode),
          productCategory: formOne.values.productCategory,
          productTitle: formOne.values.productTitle,
          productStatus: formOne.values.productStatus,
          // startDate: formOne.values.startDate,
          // endDate: formOne.values.endDate,
          // description: formOne.values.description,
          proposalFormId: data.proposalFormId,
        },
      };
      const response: any = await postRuntimeFormData(body);
      if (response?.success) {
        setOpen(false);
        setRefresh((prevState) => !prevState);
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.SUCCESS,
            message: response?.message,
          })
        );
      } else {
        setOpen(false);
        pushNotification({
          isOpen: true,
          type: CONSTANTS.ERROR,
          message: response?.message,
        });
      }
    } else {
      const body = {
        formId: PRODUCT_CODES_FORM_ID,
        formData: {
          productCode: parseInt(formOne.values.productCode),
          productCategory: formOne.values.productCategory,
          productTitle: formOne.values.productTitle,
          productStatus: formOne.values.productStatus,
          // startDate: formOne.values.startDate,
          // endDate: formOne.values.endDate,
          // description: formOne.values.description,
          proposalFormId: "",
        },
      };
      const response: any = await postRuntimeFormData(body);
      if (response?.success) {
        setOpen(false);
        setRefresh((prevState) => !prevState);
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.SUCCESS,
            message: response?.message,
          })
        );
      } else {
        setOpen(false);
        pushNotification({
          isOpen: true,
          type: CONSTANTS.ERROR,
          message: response?.message,
        });
      }
    }
  };

  useEffect(() => {
    getProductCategories();
  }, []);

  return (
    <div className={classes.productCodeFormContainer}>
      <div className={classes.formSection}>
        <div className={classes.flexRow}>
          <Box display={"flex"} flexDirection={"column"}>
            <label className={classes.fieldLabel}>Product Category</label>
            <Autocomplete
              className={classes.fieldinput}
              id="product-category"
              options={productCategories}
              getOptionLabel={(option) => option}
              value={formOne.values.productCategory}
              onChange={(_, newValue: any) =>
                formOne.setFieldValue("productCategory", newValue)
              }
              disableClearable={true}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  error={
                    formOne.touched.productCategory &&
                    Boolean(formOne.errors.productCategory)
                  }
                  helperText={
                    formOne.touched.productCategory &&
                    formOne.errors.productCategory
                  }
                />
              )}
            />
          </Box>
          <Box display={"flex"} flexDirection={"column"}>
            <label className={classes.fieldLabel}>Product Code</label>
            <TextField
              className={classes.fieldinput}
              id="product-code"
              name="productCode"
              size="small"
              onBlur={formOne.handleBlur}
              onChange={formOne.handleChange}
              value={formOne.values.productCode}
              helperText={
                formOne.touched.productCode && formOne.errors.productCode
              }
              error={
                formOne.touched.productCode &&
                Boolean(formOne.errors.productCode)
              }
            />
          </Box>
        </div>
        <div className={classes.flexRow}>
          <Box display={"flex"} flexDirection={"column"}>
            <label className={classes.fieldLabel}>Product Title</label>
            <TextField
              className={classes.fieldinput}
              id="product-title"
              name="productTitle"
              size="small"
              onBlur={formOne.handleBlur}
              onChange={formOne.handleChange}
              value={formOne.values.productTitle}
              helperText={
                formOne.touched.productTitle && formOne.errors.productTitle
              }
              error={
                formOne.touched.productTitle &&
                Boolean(formOne.errors.productTitle)
              }
            />
          </Box>
          <Box display={"flex"} flexDirection={"column"}>
            <label className={classes.fieldLabel}>Product Status</label>
            <FormControl size="small" className={classes.fieldinput}>
              <Select
                labelId="product-Status"
                id="productStatus"
                onBlur={formOne.handleBlur}
                value={formOne.values.productStatus}
                onChange={(e) => {
                  formOne.setFieldValue("productStatus", e.target.value, true);
                }}
                error={
                  formOne.touched.productStatus &&
                  Boolean(formOne.errors.productStatus)
                }
              >
                <MenuItem value={"Active"}>{"Active"}</MenuItem>
                <MenuItem value={"InActive"}>{"InActive"}</MenuItem>
              </Select>
              <FormHelperText sx={{ color: "red" }}>
                {formOne.touched.productStatus && formOne.errors.productStatus}
              </FormHelperText>
            </FormControl>
          </Box>
        </div>
        {/* <div className={classes.flexRow}>
          <Box display={"flex"} flexDirection={"column"}>
            <label className={classes.fieldLabel}>Start Date</label>
            <TextField
              className={classes.fieldinput}
              id="start-Date"
              name="startDate"
              type="date"
              helperText={formOne.touched.startDate && formOne.errors.startDate}
              error={
                formOne.touched.startDate && Boolean(formOne.errors.startDate)
              }
              value={formOne.values.startDate}
              onChange={(e) =>
                formOne.setFieldValue("startDate", e.target.value)
              }
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
            />
          </Box>

          <Box display={"flex"} flexDirection={"column"}>
            <label className={classes.fieldLabel}>End Date</label>
            <TextField
              className={classes.fieldinput}
              id="end-Date"
              name="endDate"
              type="date"
              helperText={formOne.touched.endDate && formOne.errors.endDate}
              error={formOne.touched.endDate && Boolean(formOne.errors.endDate)}
              value={formOne.values.endDate}
              onChange={(e) => formOne.setFieldValue("endDate", e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
            />
          </Box>
        </div>
        <div className={classes.flexRow}>
          <Box display={"flex"} flexDirection={"column"}>
            <label className={classes.fieldLabel}>Description</label>
            <TextField
              id="Description-ID"
              name="description"
              size="small"
              rows={3}
              multiline
              className={classes.discriptionInput}
              helperText={
                formOne.touched.description && formOne.errors.description
              }
              error={
                formOne.touched.description &&
                Boolean(formOne.errors.description)
              }
              onBlur={formOne.handleBlur}
              onChange={(e) => {
                e.preventDefault();
                formOne.setFieldValue("description", e.target.value, true);
              }}
              value={formOne.values.description}
            />
          </Box>
        </div> */}
      </div>
      <div className={classes.btnSection}>
        <Button
          color="primary"
          variant="outlined"
          onClick={() => formOne.submitForm()}
        >
          Submit
        </Button>
        <Button
          color="primary"
          variant="outlined"
          onClick={() => setOpen(false)}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default CreateProductCode;
